import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  layoutContainer: {
    overflow: 'hidden',
  },
  content: {
    overflow: 'hidden',
  },
  heading: {
    marginBottom: 10,
    fontSize: theme.fonts.sizes.font18PX,
    color: theme.colors.light.freshPowder,
    fontFamily: theme.fonts.family.primary,
    fontWeight: 900,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    background: 'transparent',
    boxShadow: 'none',
  },
  main: {
    transition: 'all 500ms ease-in-out',
  },
  Divider: {
    height: 1,
    width: 355,
    border: 'none',
    display: 'flex',
    backgroundColor: theme.colors.dark.steelBlue,
    marginBottom: 30,
  },
}));
